// extracted by mini-css-extract-plugin
export default {"container":"index_container__eOjNS","item":"index_item__288Dp","image":"index_image__Bc30f","text":"index_text__qQ1mL","active":"index_active__bSyLZ"};